import React, { useState, useEffect } from "react";
import "./OfflineClasses.css";
import BackBtn from "../../Components/BackBtn/BackBtn";
import HamburgerMenu from "../../Components/HamburgerMenu/HamburgerMenu";
import BottomBar from "../../Components/BottomBar/BottomBar";
import Alert from "../../Components/Alert/Alert";
import Axios from "axios";
import { useAuth } from "../../AuthContext";
import { useNavigate } from "react-router-dom";
import Loading from "../../Components/Loading/Loading";
import { useBaseUrl } from "../../ApiContext";

export default function OfflineClasses() {
  const { userToken } = useAuth();
  const baseUrl = useBaseUrl();
  const navigate = useNavigate();
  const [showHamburgerMenu, setShowHamburgerMenu] = useState(false);
  const [offlineClassesList, setOfflineClassesList] = useState([]);
  const [showAlert, setShowAlert] = useState(false);
  const [alertText, setAlertText] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const hamburgerMenuHandler = () => {
    setShowHamburgerMenu(true);
  };

  const hideMenuHandler = () => {
    setShowHamburgerMenu(false);
  };

  useEffect(() => {
    const fetchOfflineClasses = async () => {
      try {
        const response = await Axios.get(`${baseUrl}/offline_class`, {
          headers: {
            Authorization: `Token ${userToken}`,
          },
        });
        console.log(response.data);
        setIsLoading(false);
        if (response.data.classes.length === 0) {
          setShowAlert(true);
          setTimeout(() => {
            setShowAlert(false);
          }, 2000);
          setAlertText("موردی یافت نشد");
          return;
        }
        setOfflineClassesList(response.data.classes);
      } catch (error) {
        console.log("Error during getting offline classes", error);
        setShowAlert(true);
        setTimeout(() => {
          setShowAlert(false);
        }, 2000);
        setAlertText("خطا در برقراری ارتباط");
      }
    };
    if (userToken) {
      fetchOfflineClasses();
    }
  }, [baseUrl, userToken]);

  const handleEnterClass = (link) => {
    navigate("/class", { state: { link: link } });
  };

  return (
    <div className="gymBg bgContainer">
      <HamburgerMenu
        showHamburgerMenu={showHamburgerMenu}
        onHide={hideMenuHandler}
      />
      <div className="blurOverlay">
        <div className="pageWrapper">
          <div className="pageHeader centeredFlex">
            <BackBtn />
            <img
              src="/images/ic_menu.svg"
              alt="menu"
              className="menuIcon"
              onClick={hamburgerMenuHandler}
            />
          </div>
          <div className="pageTitle horizontalBorder">کلاس های آفلاین</div>
          {isLoading ? (
            <Loading />
          ) : (
            <div className="offlineClassesList scroll centeredFlex">
              {offlineClassesList.length > 0 &&
                offlineClassesList.map((item) => (
                  <div
                    key={item.title}
                    className="offlineClass centeredFlex"
                    onClick={() => handleEnterClass(item.link)}
                  >
                    <img
                      src="/images/videoStreaming.png"
                      alt="video"
                      className="videoStreaming"
                    />
                    {item.title}
                  </div>
                ))}
            </div>
          )}
          <Alert alertText={alertText} showAlert={showAlert} bottom="5rem" />
        </div>
      </div>
      <BottomBar />
    </div>
  );
}
